import React from 'react';
import StatCards from './StatCards';
import ReportsTimeline from './ReportsTimeline';
import ClassesTable from './ClassesTable';
import PeopleTable from './PeopleTable';
import dayjs from 'dayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import Select from 'react-select';
import { useTenant } from '../../contexts/TenantContext';




// Example students data
const students = [
  { name: 'John Doe', email: 'john@student.com', function: 'Freshman', class: 'MAT-101', status: 'Present', enrollId: '21/09/2023', avatar: 'https://randomuser.me/api/portraits/men/31.jpg' },
  { name: 'Jane Smith', email: 'jane@student.com', function: 'Sophomore', class: 'SCI-202', status: 'Absent', enrollId: '21/09/2023', avatar: 'https://randomuser.me/api/portraits/women/32.jpg' },
  { name: 'Alice Brown', email: 'alice@student.com', function: 'Junior', class: 'HIS-303', status: 'Present', enrollId: '21/09/2023', avatar: 'https://randomuser.me/api/portraits/women/33.jpg' },
  { name: 'Bob Lee', email: 'bob@student.com', function: 'Senior', class: 'MAT-206', status: 'Present', enrollId: '21/09/2023', avatar: 'https://randomuser.me/api/portraits/men/34.jpg' },
  { name: 'Carol King', email: 'carol@student.com', function: 'Freshman', class: 'CST-104', status: 'Absent', enrollId: '21/09/2023', avatar: 'https://randomuser.me/api/portraits/women/35.jpg' },
  { name: 'David Park', email: 'david@student.com', function: 'Sophomore', class: 'ENG-4010', status: 'Present', enrollId: '21/09/2023', avatar: 'https://randomuser.me/api/portraits/men/36.jpg' },
];
// Static data (copied from Dashboard.jsx)
const classes = [
  {
    id: 'MAT-101',
    name: 'MAT-101',
    staff: [
      { avatar: 'https://randomuser.me/api/portraits/men/10.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/11.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/men/12.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/13.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/men/14.jpg' },
    ],
    students: [students[0], students[2], students[4]],
    status: 'Submitted',
    attendance: '60%'
  },
  {
    id: 'SCI-202',
    name: 'SCI-202',
    staff: [
      { avatar: 'https://randomuser.me/api/portraits/men/15.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/16.jpg' },
    ],
    students: [students[1], students[3], students[5]],
    status: 'Submitted',
    attendance: '10%'
  },
  {
    id: 'HIS-303',
    name: 'HIS-303',
    staff: [
      { avatar: 'https://randomuser.me/api/portraits/men/17.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/18.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/men/19.jpg' },
    ],
    students: [students[0], students[1], students[2]],
    status: 'Submitted',
    attendance: '100%'
  },
  {
    id: 'MAT-206',
    name: 'MAT-206',
    staff: [
      { avatar: 'https://randomuser.me/api/portraits/men/20.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/21.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/men/22.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/23.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/men/24.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/25.jpg' },
    ],
    students: [students[3], students[4], students[5]],
    status: 'Submitted',
    attendance: '100%'
  },
  {
    id: 'CST-104',
    name: 'CST-104',
    staff: [
      { avatar: 'https://randomuser.me/api/portraits/men/26.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/27.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/men/28.jpg' },
    ],
    students: [students[0], students[1], students[2], students[3]],
    status: 'Submitted',
    attendance: '25%'
  },
  {
    id: 'ENG-4010',
    name: 'ENG-4010',
    staff: [
      { avatar: 'https://randomuser.me/api/portraits/men/29.jpg' },
      { avatar: 'https://randomuser.me/api/portraits/women/30.jpg' },
    ],
    students: [students[4], students[5], students[0], students[1]],
    status: 'Submitted',
    attendance: '40%'
  },
];

const reportIconData = [
  { id: 1, title: 'SCI-202 | Period 1 12/19/2025 Re-submission', time: '19 DEC 7:39 PM', bg: '#1bc47d' },
  { id: 2, title: 'HIS-303 | Period 2', time: '19 DEC 6:21 PM', bg: '#e34c4c' },
  { id: 3, title: 'SCI-202 | Period 1', time: '19 DEC 4:30 PM', bg: '#3b82f6' },
  { id: 4, title: 'ENG-4010 | Period 2', time: '19 DEC 3:01 PM', bg: '#f59e42' },
  { id: 5, title: 'MAT-101 | Period 1', time: '18 DEC 11:35 PM', bg: '#7c3aed' },
  { id: 6, title: 'CST-104 | Period 7', time: '18 DEC 4:41 PM', bg: '#a21caf' },
];



export default function TeacherDashboard() {
  const { organization, school, isLoading: tenantLoading } = useTenant();
  
  // Stat card values
  const presentStudents = 342;
  const presentStudentsChange = 10;
  const absentStudents = 15;
  const absentStudentsChange = -5;
  const teachers = 15;
  const teachersChange = -14;

  // Pagination logic for classes
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 4;
  const totalPages = Math.ceil(classes.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentClasses = classes.slice(startIndex, endIndex);

  // Pagination logic for students
  const [currentStudentPage, setCurrentStudentPage] = React.useState(1);
  const totalStudentPages = Math.ceil(students.length / itemsPerPage);
  const studentStartIndex = (currentStudentPage - 1) * itemsPerPage;
  const studentEndIndex = studentStartIndex + itemsPerPage;
  const currentStudents = students.slice(studentStartIndex, studentEndIndex);

  // Calendar state
  const [calendarValue, setCalendarValue] = React.useState(dayjs());

  // Modal states
  const [showAddStudentModal, setShowAddStudentModal] = React.useState(false);
  const [showAddReportModal, setShowAddReportModal] = React.useState(false);

  // Form states
  const [newStudent, setNewStudent] = React.useState({
    name: '',
    email: '',
    function: '',
    class: '',
    status: '',
    enrollId: '',
    avatar: '',
  });
  const [newReport, setNewReport] = React.useState({
    title: '',
    class: '',
    period: '',
    date: '',
    status: '',
    icon: '',
  });

  // Handlers for Add Student Modal
  const handleOpenAddStudent = () => setShowAddStudentModal(true);
  const handleCloseAddStudent = () => {
    setShowAddStudentModal(false);
    setNewStudent({ name: '', email: '', function: '', class: '', status: '', enrollId: '', avatar: '' });
  };
  const handleNewStudentChange = (e) => {
    setNewStudent({ ...newStudent, [e.target.name]: e.target.value });
  };
  const handleAddStudent = (e) => {
    e.preventDefault();
    // Add logic to actually add the student
    handleCloseAddStudent();
  };

  // Handlers for Add Report Modal
  const handleOpenAddReport = () => setShowAddReportModal(true);
  const handleCloseAddReport = () => {
    setShowAddReportModal(false);
    setNewReport({ title: '', class: '', period: '', date: '', status: '', icon: '' });
  };
  const handleNewReportChange = (e) => {
    setNewReport({ ...newReport, [e.target.name]: e.target.value });
  };
  const handleAddReport = (e) => {
    e.preventDefault();
    // Add logic to actually add the report
    handleCloseAddReport();
  };

  return (
    <div>
    <div className="w-full bg-[#f7fafd] flex flex-col gap-4 px-2 lg:px-8 py-8">
      {/* Tenant Info Display */}
      {!tenantLoading && (organization || school) && (
        <div className="bg-white rounded-lg p-4 mb-4 shadow-sm border border-blue-100">
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <span className="font-medium">Teaching at:</span>
            <span className="text-blue-600 font-semibold">
              {school ? `${school.name} (${organization?.name})` : organization?.name}
            </span>
          </div>
        </div>
      )}
      
      {/* Stat Cards Row (full width) */}
        <div className="mb-2">
        <StatCards
          presentStudents={presentStudents}
          presentStudentsChange={presentStudentsChange}
          absentStudents={absentStudents}
          absentStudentsChange={absentStudentsChange}
          teachers={teachers}
          teachersChange={teachersChange}
        />
        </div>
        {/* Main 2-column layout */}
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Left column: Calendar + Reports */}
          <div className="flex flex-col gap-8 w-[340px]">
            {/* Calendar Card */}
            <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-6 flex flex-col items-center w-[340px] h-[400px]">
              <DateCalendar
                value={calendarValue}
                onChange={setCalendarValue}
                views={['day']}
                sx={{
                  width: '100%',
                  '& .MuiPickersCalendarHeader-root': {
                    justifyContent: 'space-between',
                    mb: 1,
                  },
                  '& .MuiPickersCalendarHeader-label': {
                    fontWeight: 600,
                    fontSize: 18,
                  },
                  '& .MuiPickersArrowSwitcher-button': {
                    borderRadius: '8px',
                    border: '1px solid #e5e7eb',
                    color: '#1e293b',
                    background: '#f9fafb',
                    '&:hover': { background: '#e0e7ef' },
                  },
                  '& .MuiPickersDay-root': {
                    fontWeight: 500,
                    fontSize: 16,
                    borderRadius: '8px',
                  },
                  '& .Mui-selected': {
                    background: '#2563eb !important',
                    color: '#fff !important',
                  },
                  '& .MuiPickersDay-today': {
                    border: '1.5px solid #2563eb',
                  },
                  '& .MuiPickersDay-root.Mui-selected:hover': {
                    background: '#1d4ed8 !important',
                  },
                  '& .MuiPickersDay-root:hover': {
                    background: '#f1f5f9',
                  },
                  '& .MuiPickersActionBar-root': {
                    display: 'none',
                  },
                }}
                slotProps={{
                  actionBar: { actions: [] },
                }}
              />
              <button
                className="w-full mt-4 py-2 rounded-xl bg-blue-600 text-white font-semibold shadow hover:bg-blue-700 transition"
                onClick={() => setCalendarValue(dayjs())}
              >
                Today
              </button>
            </div>
            <ReportsTimeline
              reportIconData={reportIconData}
              title="Your Reports"
              date="on Dec 19, 2025"
              totalReports={reportIconData.length}
              onAddReport={handleOpenAddReport}
            />
          </div>
          {/* Right column: Classes + Students */}
          <div className="flex flex-col gap-8 flex-1">
        <ClassesTable
          classes={currentClasses}
          type="students"
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          startIndex={startIndex}
          endIndex={endIndex}
          totalItems={classes.length}
        />
            <PeopleTable
              people={currentStudents}
              type="students"
              title="Your Students"
              date="on Dec 19, 2025"
              currentPage={currentStudentPage}
              totalPages={totalStudentPages}
              onPageChange={setCurrentStudentPage}
              startIndex={studentStartIndex}
              endIndex={studentEndIndex}
              totalItems={students.length}
              onAdd={handleOpenAddStudent}
            />
          </div>
        </div>

        {/* Add Student Modal */}
        {showAddStudentModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full">
              <h3 className="text-lg font-bold text-slate-800 mb-4">Add New Student</h3>
              <form onSubmit={handleAddStudent}>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Name</label>
                    <input
                      type="text"
                      name="name"
                      value={newStudent.name}
                      onChange={handleNewStudentChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={newStudent.email}
                      onChange={handleNewStudentChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Function</label>
                    <input
                      type="text"
                      name="function"
                      value={newStudent.function}
                      onChange={handleNewStudentChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Class</label>
                    <Select
                      options={classes.map(c => ({ value: c.id, label: c.name }))}
                      value={classes.find(c => c.id === newStudent.class) ? { value: newStudent.class, label: classes.find(c => c.id === newStudent.class).name } : null}
                      onChange={(option) => setNewStudent({ ...newStudent, class: option ? option.value : '' })}
                      className="mt-1"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Status</label>
                    <select
                      name="status"
                      value={newStudent.status}
                      onChange={handleNewStudentChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    >
                      <option value="">Select Status</option>
                      <option value="Present">Present</option>
                      <option value="Absent">Absent</option>
                      <option value="Unknown">Unknown</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Enrollment ID</label>
                    <input
                      type="text"
                      name="enrollId"
                      value={newStudent.enrollId}
                      onChange={handleNewStudentChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Avatar URL</label>
                    <input
                      type="url"
                      name="avatar"
                      value={newStudent.avatar}
                      onChange={handleNewStudentChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={handleCloseAddStudent}
                    className="px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                  >
                    Add Student
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Add Report Modal */}
        {showAddReportModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full">
              <h3 className="text-lg font-bold text-slate-800 mb-4">Add New Report</h3>
              <form onSubmit={handleAddReport}>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Title</label>
                    <input
                      type="text"
                      name="title"
                      value={newReport.title}
                      onChange={handleNewReportChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Class</label>
                    <Select
                      options={classes.map(c => ({ value: c.id, label: c.name }))}
                      value={classes.find(c => c.id === newReport.class) ? { value: newReport.class, label: classes.find(c => c.id === newReport.class).name } : null}
                      onChange={(option) => setNewReport({ ...newReport, class: option ? option.value : '' })}
                      className="mt-1"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Period</label>
                    <input
                      type="text"
                      name="period"
                      value={newReport.period}
                      onChange={handleNewReportChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Date</label>
                    <input
                      type="date"
                      name="date"
                      value={newReport.date}
                      onChange={handleNewReportChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Status</label>
                    <select
                      name="status"
                      value={newReport.status}
                      onChange={handleNewReportChange}
                      className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                      required
                    >
                      <option value="">Select Status</option>
                      <option value="Submitted">Submitted</option>
                      <option value="Pending">Pending</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">Icon Color</label>
                    <input
                      type="color"
                      name="icon"
                      value={newReport.icon}
                      onChange={handleNewReportChange}
                      className="mt-1 block w-full h-10 rounded-lg border border-slate-300"
                      required
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={handleCloseAddReport}
                    className="px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                  >
                    Add Report
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
} 